export default {
    common: {
        confirm: '確認',
        cancel: '取消',
        back: '返回',
        search: '搜尋',
        submit: '提交',
        other: '其他',
        default: '預設',
        color_tag: '顏色標籤',
        option: '選項',
        success: '成功',
        error: '錯誤',
        sending: '發送中',
        send_success: '發送成功',
        send_error: '發送失敗',
        visits: '造訪',
        table: '桌位',
        'one-way-message': '單向簡訊',
        'two-way-message': '雙向簡訊',
        'one-way-voice': '單向語音',
        'two-way-voice': '雙向語音',
    },
    setting: {
        setting: '設定',
        general: '一般',
        account: '帳戶',
        about: '關於',
        custom_language_label: '自訂語言',
        dark_mode_label: '深色模式',
        dark_mode_on: '開',
        dark_mode_off: '關',
        logo_label: '餐廳標誌',
        name_label: '餐廳名稱',
        version_label: '版本',
        privacy_label: '隱私權聲明',
        terms_label: '服務條款',
        logout_btn: '登出',
        logout_tip: '要登出目前帳號嗎？'
    },
    waitlist: {
        waitlist: '候位',
        all: '全部',
        no_show: '過號',
        check_in: '簽到',
        checked_in: '準備入座',
        waiting: '等待中',
        notify: '通知',
        seat: '入座',
        add_waitlist: '新增排隊',
        guest_number: '客人數量',
        guest_name: '客人姓名',
        phone_num: '電話號碼',
        visit_note: '備註',
        onsite_notify: '現場通知',
        table_ready: '用餐準備',
        broadcast: '大螢幕廣播',
        two_way_sms: '雙向簡訊',
        two_way_voice: '雙向語音',
        resend_invite: '重新邀請',
        seat_with_table: '帶餐桌入座',
        waitlist_detail: '排隊詳情',
        table_assign: '關聯真實餐桌',
        timeline: '時間軸',
        not_arrived: '未到',
        partial_arrived: '部分到達',
        all_arrived: '全部到達',
        join_waitlist: '加入排隊',
        input_name_tip: '請輸入客人姓名',
        choose_people_num_tip: '請選擇客人數量',
    },
    reserve: {
        reserve: '預約'
    },
    floorplan: {
        floorplan: '平面圖'
    },
    sso: {
        title: 'SSO 登入',
        verifying: '正在驗證帳號...',
        success: '登入成功',
        need_register: '尚未註冊，正在跳轉註冊頁...',
        missing_token: '缺少 SSO Token，請返回重試',
        verify_failed: 'SSO 驗證失敗，請重試',
        retry: '重試',
        back_login: '返回登入'
    },
    register: {
        title: '建立商戶帳號',
        desc: '完成註冊後即可使用 Minitable',
        tappo_id: 'Tappo ID',
        merchant_name: '商戶名稱',
        merchant_name_ph: '餐廳 / 商戶名稱',
        email: '電郵',
        email_ph: '登入電郵',
        phone: '電話',
        phone_ph: '聯絡電話',
        place_id: 'Place ID',
        place_id_ph: 'Google Place ID（選用）',
        submit: '建立帳號',
        back_login: '返回登入',
        missing_required: '請填寫商戶名稱、電郵和電話',
        submit_failed: '註冊失敗，請重試'
    },
};
